import React from 'react'
import { Button, Result } from 'antd'
import { Link } from 'react-router-dom'

export default function AutoTagSuccess() {
  return (
    <Result
      status="success"
      title="Solicitação realizada com sucesso"
      subTitle="Se trocou a senha, sua conta Auto Tag deve ser acessada pelo aplicativo Instabov. Abra o app no seu celular e faça login com a nova senha."
      extra={[
        <Link to="/logout" key="logout-link">
          <Button type="primary">Voltar ao login</Button>
        </Link>,
      ]}
    />
  )
}
